<script setup lang="ts">
import 'emoji-mart-vue-fast/css/emoji-mart.css';
import { type EmojiData, Picker } from 'emoji-mart-vue-fast/src';
import { emojiIndex } from '@/lib/emoji.ts';
import { useForwardPropsEmits } from 'reka-ui';

interface EmojiPickerProps {
    perLine?: number;
    maxSearchResults?: number;
    emojiSize?: number;
    title?: string;
    emoji?: string;
    color?: string;
    set?: string;
    skin?: number;
    defaultSkin?: number;
    native?: boolean;
    emojiTooltip?: boolean;
    autoFocus?: boolean;
    i18n?: any;
    showPreview?: boolean;
    showSearch?: boolean;
    showCategories?: boolean;
    showSkinTones?: boolean;
    infiniteScroll?: boolean;
    pickerStyles?: any;
    data?: any;
}

const props = withDefaults(defineProps<EmojiPickerProps>(), {
    color: 'none',
    set: 'apple',
    showPreview: false,
    data: emojiIndex,
});

const emit = defineEmits<{
    select: [emoji: EmojiData];
}>();
const forwarded = useForwardPropsEmits(props, emit);
</script>

<template>
    <Picker class="shadow-md rounded-lg! font-manrope!" v-bind="forwarded" />
</template>

<style lang="css">
.emoji-mart {
    background-color: var(--color-card-primary);
    border-color: var(--color-border-default);
}

.emoji-mart-bar:first-child {
    border-bottom-width: 0;
}

.emoji-mart-category-label h3 {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    padding-top: 16px;
    padding-bottom: 8px;
    color: var(--color-foreground-muted);
}

.emoji-mart-search {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    color: var(--color-foreground-muted);
    margin-top: 12px;
}

.emoji-mart-anchor {
    color: hsla(225, 3%, 71%, 1);
}

.emoji-mart-anchor-selected {
    color: var(--color-foreground-primary);
}

.emoji-mart-anchor:hover,
.emoji-mart-anchor-selected {
    color: var(--color-foreground-primary);
}

.emoji-mart-anchor-bar {
    background-color: var(--color-patilla-500);
}

.emoji-mart-search > input {
    border-radius: 8px;
    border: 1px solid var(--color-border-default, #e5e7eb);
    background: var(--color-surface-input);

    box-shadow: 0 1px 2px 0 rgba(31, 41, 55, 0.05);
}
</style>
